module.exports = __webpack_public_path__ + "04_short_brown.0c567edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_short_brown.png
// module id = 0Uuo
// module chunks = 0